import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AvanoPipesModule } from '@avano/avano-components/pipes/avano-pipes.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { AvanoButtonModule } from '../avano-button/avano-button.module';
import { AvanoPanelModule } from "../avano-panel/avano-panel.module";
import { AvanoPopoverModule } from '../avano-popover/avano-popover.module';
import { AvanoDirectivesModule } from "../directives/avano-directives.module";
import { AvanoTableColumnHeaderComponent } from './avano-table-column-header/avano-table-column-header.component';
import { AvanoTableSettingsComponent } from './avano-table-settings/avano-table-settings.component';
import { AvanoTableComponent } from './avano-table.component';
import { NumberInputCellComponent } from './cell-renderers/number-input-cell/number-input-cell.component';
import { TextWithIconCellRenderer } from './cell-renderers/text-with-icon/text-with-icon.cell-renderer';
import { TextInputColumnFilterComponent } from './column-filters/text-input-column-filter.component';
import { AvanoResizableColumn, CustomPReordable, CustomPResizable, CustomPSortable } from './directives/avano-table-header.directive';
import { TableFiltersResetComponent } from './table-filters-reset/table-filters-reset.component';
const components = [
  AvanoTableComponent,
  AvanoTableSettingsComponent,
  NumberInputCellComponent,
  TableFiltersResetComponent,
  TextInputColumnFilterComponent,
  AvanoTableColumnHeaderComponent,
  CustomPReordable,
  CustomPResizable,
  AvanoResizableColumn,
  CustomPSortable,
  TextWithIconCellRenderer
]


@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild({ extend: true }),
    CheckboxModule,
    AvanoPopoverModule,
    AutoCompleteModule,
    AvanoButtonModule,
    FormsModule,
    ButtonModule,
    TableModule,
    AvanoPanelModule,
    AvanoDirectivesModule,
    AvanoPipesModule
  ],
  exports: [
    TableModule,
    ...components
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: getSelectedLanguage,
      deps: [TranslateService]
    }
  ],
  declarations: [
    ...components,
  ]
})
export class AvanoTableModule { }

// TODO: This needs to be reworked, the language-selection is not soley based on the browser language
// Have a look here: https://jira-agile.rt.ipnt.de/browse/UX-1218
// In SCIP it is implemented like it should be within the InitTranslationService
export function getSelectedLanguage(translateService: TranslateService): string {
  const browserLang = translateService.getBrowserLang();
  return browserLang ?? 'en';
}
